export const experiencesQueryKeys = {
  all: ['experiences'] as const,
  offers: () => [...experiencesQueryKeys.all, 'offers'] as const,
  offerDetail: (offerId: string, brand: string) =>
    [...experiencesQueryKeys.offers(), 'detail', offerId, brand] as const,
  collections: () => [...experiencesQueryKeys.all, 'collections'] as const,
  collectionsList: (onlyActive?: boolean) => [...experiencesQueryKeys.collections(), { onlyActive }] as const,
  carouselMetrics: () => [...experiencesQueryKeys.all, 'carouselMetrics'] as const,
  carouselMetricsList: () => [...experiencesQueryKeys.carouselMetrics(), 'list'] as const,
  syncLogs: () => [...experiencesQueryKeys.all, 'syncLogs'] as const,
  syncLogsList: (offerId: string) => [...experiencesQueryKeys.syncLogs(), offerId] as const,
  urgencyTags: () => [...experiencesQueryKeys.all, 'urgencyTags'] as const,
  urgencyTagsList: () => [...experiencesQueryKeys.urgencyTags(), 'list'] as const,
};
